export function formatNumberWithSign(value: number) {
  const formatted = new Intl.NumberFormat('en-US', {
    signDisplay: 'always',
  }).format(value);
  return formatted;
}
